import { render, staticRenderFns } from "./ButtonNotificationsSetup.vue?vue&type=template&id=39a16132&"
import script from "./ButtonNotificationsSetup.vue?vue&type=script&lang=js&"
export * from "./ButtonNotificationsSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports